import {h} from 'preact';
import Layout from '../Layout';
import config from '../../config.json';
import DeadlineList from '../DeadlineList';
import { useEffect } from 'preact/hooks';
import dayjs from 'dayjs';
import TaskSize from '../TaskSize';
import TypeOfPaper from '../TypeOfPaper';
import urlParser from '../../utils/urlParser';

export default function Programming(props) {
  const {
    state,
    setState
  } = props;
  const {
    configsForProgramming: {
      deadlines,
      sizes,
      defaults,
      disciplinesIds
    }
  }  = config;
  useEffect(() => {
    const params = urlParser();
    setState({
      ...state,
      disciplineId: disciplinesIds.includes(+params?.topcatId) ? +params?.topcatId : defaults.disciplineId,
      deadline: {
        ...state.deadline,
        id: +params?.tariffId || defaults.deadlineId,
        value: dayjs()
          .add(deadlines.filter(i => i.id === (+params?.tariffId || defaults.deadlineId))[0].hours, 'hours')
          .format('MMM DD, YYYY [at] HH:mm A')
          .toString()
      },
      size: {
        id: defaults.sizeId,
        name: sizes.filter(s => defaults.sizeId === s.id)[0].name
      },
    });
  }, []);


  return (
    <div className="programming">
      <Layout.Row>
        <div className="form-control">
          <TypeOfPaper
            state={state}
            setState={setState}
            disciplinesIds={disciplinesIds}
          />
        </div>
      </Layout.Row>
      <Layout.Row>
        <div className="form-control">
          <span>Deadline</span>
          <div>
            <DeadlineList
              deadlines={deadlines}
              state={state}
              setState={setState}
            />
          </div>
        </div>
      </Layout.Row>
      <Layout.Row>
        <div className="form-control">
          <span>Task size</span>
          <TaskSize
            sizes={sizes}
            state={state}
            setState={setState}
          />
        </div>
      </Layout.Row>
    </div>
  )
}
